import { render, staticRenderFns } from "./rabbitmq.vue?vue&type=template&id=63b8ec0d&scoped=true"
import script from "./rabbitmq.component.js?vue&type=script&lang=js&external"
export * from "./rabbitmq.component.js?vue&type=script&lang=js&external"
import style0 from "./rabbitmq.vue?vue&type=style&index=0&id=63b8ec0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8ec0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTextField})
